const f = {
  red: {
    100: "#fff0e8ff",
    200: "#fedfd5ff",
    300: "#ffbcadff",
    400: "#fa7a64ff",
    500: "#e54a32ff",
    600: "#b83525ff",
    700: "#822824ff",
    800: "#592728ff",
    900: "#402629ff",
    1e3: "#2b2123ff",
    default: "#e54a32ff",
    accent: "#ff4747ff"
  },
  orange: {
    100: "#fff2e8ff",
    200: "#ffe4d1ff",
    300: "#fac096ff",
    400: "#f5964eff",
    500: "#d67022ff",
    600: "#a35214ff",
    700: "#7a4518ff",
    800: "#573b23ff",
    900: "#3d2f22ff",
    1e3: "#2b241dff",
    default: "#d67022ff",
    accent: "#ff8b33ff"
  },
  yellow: {
    100: "#fff6e5ff",
    200: "#ffeeccff",
    300: "#ffdd99ff",
    400: "#fabf5aff",
    500: "#e09c24ff",
    600: "#ac771bff",
    700: "#7a581dff",
    800: "#574323ff",
    900: "#403521ff",
    950: "#403521ff",
    1e3: "#2b261dff",
    default: "#e09c24ff",
    accent: "#ffb83dff"
  },
  green: {
    100: "#f2fff0ff",
    200: "#e0fcdeff",
    300: "#b9edbdff",
    400: "#83db9cff",
    500: "#47c47dff",
    600: "#2d8556ff",
    700: "#28704cff",
    750: "#2e5940ff",
    800: "#2e5940ff",
    900: "#283b2dff",
    1e3: "#222923ff",
    default: "#47c47dff",
    accent: "#56f09eff"
  },
  slate: {
    100: "#f2f9fcff",
    200: "#e1eef5ff",
    300: "#ccdee8ff",
    400: "#a9c4d4ff",
    500: "#82a7baff",
    600: "#658b9eff",
    700: "#486878ff",
    800: "#344852ff",
    900: "#283338ff",
    1e3: "#1f2426ff",
    default: "#82a7baff",
    accent: "#47c2ffff"
  },
  cobalt: {
    100: "#ebf5ffff",
    200: "#d1e8ffff",
    300: "#9ecbffff",
    400: "#66a3ffff",
    500: "#4176faff",
    600: "#304ddbff",
    700: "#263aadff",
    800: "#1c2674ff",
    900: "#171952ff",
    1e3: "#0e0e33ff",
    default: "#4176faff",
    accent: "#47a3ffff"
  },
  purple: {
    100: "#f9f2ffff",
    200: "#f2e5ffff",
    300: "#d7baf5ff",
    400: "#ad82d8ff",
    500: "#9163bfff",
    600: "#774ba3ff",
    700: "#5d407aff",
    800: "#48335cff",
    900: "#31253dff",
    1e3: "#271f2eff",
    default: "#9163bfff",
    accent: "#c285ffff"
  },
  lilac: {
    100: "#fcf9ffff",
    200: "#ecdeffff",
    300: "#cda9ffff",
    400: "#ac6fffff",
    500: "#9747fcff",
    600: "#7935cfff",
    700: "#5e18b7ff",
    800: "#431379ff",
    900: "#361055ff",
    1e3: "#220a33ff",
    default: "#9747fcff",
    accent: "#7100ffff"
  },
  magenta: {
    100: "#fff2f4ff",
    200: "#ffe5eaff",
    300: "#ffc7d3ff",
    400: "#e5859fff",
    500: "#bf5878ff",
    600: "#a34b6bff",
    700: "#863e5cff",
    800: "#5e3146ff",
    900: "#3d2531ff",
    1e3: "#2e2126ff",
    default: "#bf5878ff",
    accent: "#ff5caaff"
  },
  charcoal: {
    100: "#f9fafaff",
    200: "#f1f3f5ff",
    300: "#dfe6ebff",
    400: "#c8d3deff",
    500: "#abb9c7ff",
    530: "#abb9c7ff",
    550: "#abb9c7ff",
    600: "#7e8e9eff",
    650: "#7e8e9eff",
    700: "#556575ff",
    800: "#405261ff",
    900: "#314351ff",
    1e3: "#253642ff",
    1100: "#1d2b36ff",
    1200: "#131b24ff",
    default: "#abb9c7ff"
  },
  clay: {
    100: "#faf8f7ff",
    200: "#f5f2f0ff",
    300: "#ede8e6ff",
    400: "#ded5d1ff",
    500: "#c2b4acff",
    600: "#9e8f88ff",
    700: "#8a7b74ff",
    800: "#756963ff",
    900: "#574f4bff",
    1e3: "#4a4441ff",
    1100: "#33302eff",
    1200: "#262423ff",
    default: "#c2b4acff"
  },
  functional: {
    link: {
      default: "#304ddbff",
      hovered: "#263aadff",
      pressed: "#1c2674ff",
      disabled: "#abb9c7ff"
    },
    text: {
      headline: "#131b24ff",
      dark: "#314351ff",
      default: "#405261ff",
      light: "#556575ff"
    },
    success: {
      text: "#222923ff",
      icon: "#47c47dff",
      border: "#b9edbdff",
      background: "#f2fff0ff"
    },
    error: {
      text: "#822824ff",
      icon: "#e54a32ff",
      border: "#ffbcadff",
      background: "#fff0e8ff"
    },
    warning: {
      text: "#574323ff",
      icon: "#fabf5aff",
      border: "#ffeeccff",
      background: "#fff6e5ff"
    }
  },
  basics: {
    white: "#ffffffff",
    black: "#000000ff",
    magenta: "#ff00ffff",
    cyan: "#00ffffff"
  },
  action: {
    default: "#304ddbff",
    base: "#304ddbff",
    hover: "#263aadff",
    active: "#1c2674ff",
    focus: "#304ddbff",
    disabled: "#405261ff",
    pressed: "#1c2674ff"
  },
  link: {
    default: "#304ddbff",
    base: "#304ddbff",
    hover: "#263aadff",
    active: "#1c2674ff",
    pressed: "#1c2674ff",
    focus: "#304ddbff",
    disabled: "#405261ff"
  },
  focusRing: {
    default: {
      innerColor: "#304ddbff",
      outerColor: "rgba(121, 188, 255, 0.5)",
      innerColorOverDark: "#47a3ffff",
      outerColorOverDark: "#314351ff"
    },
    error: {
      innerColor: "#e54a32ff",
      outerColor: "#ff5caaff",
      innerColorOverDark: "#e54a32ff",
      outerColorOverDark: "#ff5caaff"
    },
    warning: {
      innerColor: "#fabf5aff",
      outerColor: "#fff6e5ff",
      innerColorOverDark: "#fabf5aff",
      outerColorOverDark: "#fff6e5ff"
    },
    success: {
      innerColor: "#47c47dff",
      outerColor: "#f2fff0ff",
      innerColorOverDark: "#47c47dff",
      outerColorOverDark: "#f2fff0ff"
    }
  },
  text: {
    default: "#405261ff",
    headline: "#131b24ff",
    dark: "#314351ff",
    light: "#556575ff",
    disabled: "#7e8e9eff",
    subtle: "#405261ff",
    slightlyMuted: "#556575ff",
    muted: "#556575ff",
    faint: "#7e8e9eff",
    extraMuted: "#abb9c7ff"
  },
  border: {
    default: "#dfe6ebff",
    divider: "#f1f3f5ff",
    ui: "#abb9c7ff"
  },
  state: {
    error: {
      text: "#b83525ff",
      backgroundDark: "#b83525ff",
      icon: "#ff4747ff",
      borderColor: "#e54a32ff",
      backgroundLight: "#fff0e8ff",
      default: "#b83525ff",
      color: "#b83525ff"
    },
    info: {
      text: "#263aadff",
      backgroundDark: "#304ddbff",
      icon: "#4176faff",
      borderColor: "#4176faff",
      backgroundLight: "#ebf5ffff",
      default: "#263aadff",
      color: "#263aadff"
    },
    success: {
      text: "#222923ff",
      backgroundDark: "#2d8556ff",
      icon: "#47c47dff",
      borderColor: "#47c47dff",
      backgroundLight: "#f2fff0ff",
      default: "#222923ff",
      color: "#222923ff"
    },
    warning: {
      text: "#a35214ff",
      backgroundDark: "#a35214ff",
      icon: "#ffb83dff",
      borderColor: "#fabf5aff",
      backgroundLight: "#fff6e5ff",
      color: "#a35214ff",
      default: "#e09c24ff"
    },
    danger: {
      default: "#b83525ff",
      backgroundLight: "#fff0e8ff",
      backgroundDark: "#b83525ff",
      borderColor: "#e54a32ff",
      color: "#b83525ff",
      text: "#b83525ff",
      icon: "#ff4747ff"
    }
  },
  background: {
    surface: "#ffffffff",
    body: "#f9fafaff"
  },
  ai: {
    light: {
      default: "#fcf9ffff",
      angle: "linear-gradient(238deg, #FFA977 5.4%, #FF85DA 33.68%, #7D77FF 67.8%, #68ECE6 95.59%)",
      linear: "linear-gradient(180deg, #FFA977 0%, #FF85DA 50%, #7D77FF 100%)"
    },
    dark: {
      default: "#9747fcff",
      angle: "linear-gradient(122deg, #2835DB 18.41%, #AD4AFB 74.17%)",
      linear: "linear-gradient(180deg, #2835DB 0%, #AD4AFB 100%)"
    }
  },
  pastel: {
    light: {
      blue: "#ACE3FF",
      green: "#BCF1CA",
      grey: "#dfe6ebff",
      purple: "#DDCCFF",
      red: "#FFAFB1",
      yellow: "#FFE258",
      teal: "#A8F0EC",
      pink: "#FFCAFE",
      orange: "#FFBE6B",
      creme: "#FFFBF2"
    },
    dark: {
      blue: "#13AFFF",
      green: "#3DD766",
      grey: "#7C92A1",
      purple: "#7733FF",
      red: "#FF161C",
      yellow: "#BE9D00",
      teal: "#74B9B6",
      pink: "#CB7ACA",
      orange: "#C78B3D",
      creme: "#FFFBF2"
    }
  }
};
export {
  f as color
};
